// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// ── Service Tiers ────────────────────────────────────────────────
/**
 * The states a service tier can be in. One list: the create and update
 * schemas, the status route and the Service Tiers page all read it. `archived`
 * was accepted at create while the status route refused it, so a tier could be
 * born in a state no transition reaches.
 */
export const SERVICE_TIER_STATUSES = ['draft', 'active', 'deprecated'];
// ── Deliverable Templates ────────────────────────────────────────
/*
 * Sprint 63.8.2 (OD48) — runtime companions to the three template unions.
 *
 * The backend validates a template create/update against these arrays and the
 * page builds its selects from them, so the list the server accepts and the list
 * the screen offers are one list. Each union is derived from its array, never
 * transcribed beside it.
 */
export const DELIVERABLE_TYPES = [
    'report',
    'review',
    'assessment',
    'meeting',
    'configuration',
];
export const DELIVERABLE_FREQUENCIES = ['one_time', 'monthly', 'quarterly', 'annually'];
export const DELIVERABLE_TEMPLATE_STATUSES = ['active', 'deprecated'];
/**
 * Runtime companion to `DeliverableInstanceStatus` (Sprint 63.8.2). The instance
 * create/update schemas and `DeliverableService`'s status whitelist read this
 * one list; it replaced two hand-written copies inside the service.
 */
export const DELIVERABLE_INSTANCE_STATUSES = [
    'upcoming',
    'in_progress',
    'completed',
    'overdue',
    'deferred',
];
/**
 * Runtime companion to `TicketStatus` — the single source of truth for status
 * validation on BOTH sides of the wire.
 *
 * The backend used to validate `PATCH /support-tickets/:id/status` against a
 * hand-written array in `support-ticket-service.ts` that had drifted from this
 * union in both directions: it rejected `triaged` and `waiting_on_vendor`
 * (which the UI dropdown offers, because the dropdown is built from the union),
 * and it accepted `open`, `waiting_on_partner` and `reopened`, which no client
 * can produce. Selecting "Triaged" in the UI therefore always threw a 400 —
 * and because the route was an unguarded async handler on Express 4, that 400
 * never reached the client as a response at all; the request hung.
 *
 * Two lists meaning "the valid statuses" is the defect. Keep this array and the
 * union above in lockstep; `satisfies` makes a divergence a compile error
 * rather than a runtime rejection.
 */
export const TICKET_STATUSES = [
    'new',
    'triaged',
    'in_progress',
    'waiting_on_client',
    'waiting_on_vendor',
    'escalated',
    'resolved',
    'closed',
];
// ── Workflow Templates ───────────────────────────────────────────
// Sprint 63.8.2 gate E12.5 remediation A — a value, so the strict
// `CreateWorkflowTemplateSchema` builds its enum from this list rather than a
// second hand-written copy of it.
export const WORKFLOW_TEMPLATE_CATEGORIES = [
    'onboarding',
    'incident_escalation',
    'config_change',
    'periodic_review',
    'offboarding',
    'custom',
];
//# sourceMappingURL=partner-marketplace.js.map